<template>
  <div>
    <div :style="{ fontSize: fonts.font30 + 'px' }"
    >Setup Transfer Pins</div>
    <div class="textArea" :style="{ fontSize: fonts.font16 + 'px' }">
      So member can transfer money TO your account
    </div>
    <!-- <div>callOption='{{callOption}}'</div> -->
    <sendPin v-if="callOption === 'auth'"
      v-bind:acct="siFormUser"
      optType="setupPins"
      type="Authorization"
      opt1="PINS"
      opt2=""
      opt3=""
      opt4="">
    </sendPin>
    <modal name="wpResult"
           :width="300"
           :height="150"
           :clickToClose="false">
      <div class="wpResult">
        <div id="wpTitle">Save of PINS successful</div>
        <div>Other members can use these PINS to transfer money to you</div>
          <button id="wprOK" @click="wprOK">OK</button>
      </div>
    </modal>
    <div v-if="callOption === 'edit'">
      <div :style="{ fontSize: fonts.font14 + 'px' }">
        <hr>
        <p>Pins to give to another member to allow them<br />
          to transfer money TO your account</p>
        <p v-if="showPinHelp === true"
          class="helpBoxLeft" :style="{ fontSize: fonts.font14 + 'px'}">
          These pins are used in conjunction with the OTHER button in the DESTINATION ACCOUNT
          box on the transfer page.  The member that will be RECEIVING the money
          will setup the pins on their account that they will then give to the member who
          is SENDING the money.  Two PINS can be setup. One that allows the SENDING member
          to see balances and loan payment amounts and one that hides that information.
          You would give the SENDING member whichever PIN you prefer.
          You can also check either box that allows the PIN to be used only once,
          in which case the PIN will be blanked out after the money is transferred.<br />
          PIN values may be 1000 thru 9999, or blank to disable.<br />
          <b-button class="btnSmallGreen"
                    @click="closeHelp">
            Close
          </b-button>
        </p>
        <hr>
        <p :style="{ fontSize: fonts.font16 + 'px', color: 'blue' }">Balances are visible</p>
        <b-form-checkbox
          v-model="otVisible"
        >Allow this PIN ONE-TIME-ONLY
        </b-form-checkbox>
        <b-form-input :name="iPinVisible"
                      :id="vPinRand"
                      autocomplete="nope"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      class="pinInput"
                      aria-label="Destination Visible Pin"
                      type="text"
                      v-model="iPinVisible"
                      required
                      placeholder="Visible Pin">
        </b-form-input>
        <hr>
        <p :style="{ fontSize: fonts.font16 + 'px', color: 'blue' }">Balances are hidden</p>
        <b-form-checkbox
          v-model="otHidden"
        >Allow this PIN ONE-TIME-ONLY
        </b-form-checkbox>
        <b-form-input :name="iPinHidden"
                      :id="hPinRand"
                      autocomplete="nope"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      class="pinInput"
                      aria-label="Destination Hidden Pin"
                      type="text"
                      v-model="iPinHidden"
                      required
                      placeholder="Hidden Pin">
        </b-form-input>
      </div>
      <b-button-group>
        <b-button class="btnGreen"
                  @click="savePins">
          Save Pins
        </b-button>
        <b-button class="btnRed"
                  @click="cancel">
          Cancel
        </b-button>
        <b-button class="btnBlue"
                  @click="pinHelp">
          Help
        </b-button>
      </b-button-group>
      <div>&nbsp;</div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import utl from '../myUtils';
import sendPin from './sendPin';

export default {
  components: {
    sendPin,
  },
  name: 'setupPins',
  props: ['callOption'],
  data() {
    return {
      phone: '',
      pin: '',
      how: 'Text',
      access: 'one',
      otVisible: false,
      otHidden: false,
      iPinVisible: '',
      iPinHidden: '',
      showOtherHelp: false,
      showPinHelp: false,
      vPinRand: '',
      hPinRand: '',
    };
  },
  watch: {
    wpCount() { // Anytime wpCount changes, update the local variables
      this.otVisible = this.wp.otVisible;
      this.otHidden = this.wp.otHidden;
      this.iPinVisible = this.wp.iPinVisible.toString();
      this.iPinHidden = this.wp.iPinHidden.toString();
      if (this.wp.iPinVisible === 0) { this.iPinVisible = ''; this.otVisible = false; }
      if (this.wp.iPinHidden === 0) { this.iPinHidden = ''; this.otHidden = false; }
    },
    wpResult() {
      if (this.wpResult === true) {
        this.$modal.show('wpResult');
      } else {
        this.$modal.hide('wpResult');
      }
    },
  },
  computed: {
    wpResult() {
      return this.$store.getters.getWpResult;
    },
    wpCount() {
      return this.$store.getters.getWpCount;
    },
    wp() {
      return this.$store.getters.getWpData;
    },
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    member() {
      return this.$store.getters.getMember;
    },
    siFormUser() {
      return this.$store.getters.getSiFormUser;
    },
    navVer() {
      return this.$store.getters.getNavVer;
    },
    wpPin() {
      return this.$store.getters.getWpPin;
    },
    wpIdx() {
      return this.$store.getters.getWpIdx;
    },
  },
  methods: {
    wprOK() {
      this.$store.commit('clrWpResult');
      window.history.back(); // Back to Phone Auth page
      window.history.back(); // Back to Transfer Page
      window.history.back(); // Back to Share/Loan summary page
    },
    inputGotFocus() {
      this.hideConfirm();
      this.hideAlert();
    },
    cancel() { // Go Back
      window.history.back(); // Back to Phone Auth page
      window.history.back(); // Back to Transfer Page
    },
    savePins() {
      const cuInfo = {};
      cuInfo.cun = this.cun;
      cuInfo.acct = this.acct;
      cuInfo.option = 'edit';
      cuInfo.otVisible = this.otVisible; // One Time Hidden (true/false)
      cuInfo.iPinVisible = this.iPinVisible; // Pin for visible balances
      cuInfo.otHidden = this.otHidden; // One Time Hidden (true/false)
      cuInfo.iPinHidden = this.iPinHidden; // Pin for hidden balances
      cuInfo.wpPin = this.wpPin;
      cuInfo.wpIdx = this.wpIdx;
      this.wsSend('c4SetXferPins', cuInfo);
      this.showConfirm('Saving PINS to server...');
    },
    pinHelp() {
      this.showPinHelp = !this.showPinHelp;
    },
    closeHelp() {
      this.showPinHelp = false;
    },
    hideConfirm() {
      this.$store.commit('setConfirmShow', false);
    },
    showConfirm(message) {
      this.$store.commit('setConfirmMessage', message);
    },
    hideAlert() {
      this.$store.commit('setAlertShow', false);
    },
    showAlert(message) {
      this.$store.commit('setAlertMessage', message);
    },
    diag(message) {
      this.$store.commit('showDiag', message);
    },
    writeDiag(message) {
      this.$store.commit('putDiag', message);
    },
    wsSend(rpc, myObject) {
      const data = Object.assign({}, myObject);
      data.rpcName = rpc;
      this.$store.commit('sendObjToServer', data);
    },
    goBack() {
      // this.$store.commit('setPageIndex', 0); /* go to pg 0 since we aren't logged in */
      window.history.back();
    },
  },
  mounted() {
    this.$store.commit('setEnablePinOK', false);
    const myDate = +new Date();
    // this.xPinRand = `xpr${myDate}`;
    this.vPinRand = `vis${myDate}`;
    this.hPinRand = `hid${myDate}`;
  },
};
</script>

<style scoped>
.pinInput {
  margin: auto;
  width: 110px;
}
.helpBox {
  border: solid 4px red;
  background-color: white;
  padding: 4px 10px 4px 10px; /* top, right, bottom, left*/
}
.btnGreen {
  background-color: lime;
  color: black;
  font-weight: bold;
  top: 10px;
  margin-left: 6px;
  margin-right: 6px;
}
.btnSmallGreen {
  background-color: lime;
  color: black;
  font-size: 10px;
  font-weight: bold;
  top: 10px;
  margin-left: 6px;
  margin-right: 6px;
}
.btnRed {
  background-color: red;
  color: black;
  font-weight: bold;
  top: 10px;
  margin-left: 6px;
  margin-right: 6px;
}
.btnBlue {
  background-color: cyan;
  color: black;
  font-weight: bold;
  top: 10px;
  margin-left: 6px;
  margin-right: 6px;
}
.wpResult {
  position: relative;
  height: 100%;
  background-color: #e0e0ff;
  border: solid 2px black;
  text-align: center;
  z-index: 999;
}
#wpTitle {
  background-color: blue;
  color: white;
  text-align: center;
  z-index: 999;
}
#wprOK {
  position: absolute;
  top: 100px;
  left: 112px;
  width: 75px;
  background-color: lime;
}
.helpBoxLeft {
  padding-left: 10px;
  padding-right: 10px;
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/components/setupPins.vue